export const BookingSteps = {
    OPTIONS: 1,
    USER_INFO: 2,
    PAYMENT: 3,
    CONFIRMATION: 4
};